import { queryOptions } from '@tanstack/react-query'

import { SettingsService } from '@inter-ikea-kompis/services'
import type { IDexfSettings } from '@inter-ikea-kompis/types'

import { getDexfFilterSegment, KOMPIS_SERVICE_BASE_SETTINGS } from '@/integrations/kompis/constants'

export interface ExtendedDexfSettings extends IDexfSettings {
  gallery: {
    'app-url': string
  }
  appsettings: {
    plannerLink: string
    showPriceDisclaimer: boolean
  }
}

export function dexfSettingsQueryOptions(locale: string) {
  return queryOptions({
    queryFn: () => getAppSettings(locale),
    queryKey: ['dexf-settings', locale],
    staleTime: Infinity,
  })
}

async function getAppSettings(locale: string) {
  const settingsService = new SettingsService({ ...KOMPIS_SERVICE_BASE_SETTINGS, locale })
  return (await settingsService.getApplicationSettings(getDexfFilterSegment())) as ExtendedDexfSettings
}
